import { render, staticRenderFns } from "./Tagsinput.vue?vue&type=template&id=03e8221b&scoped=true"
import script from "./Tagsinput.vue?vue&type=script&lang=js"
export * from "./Tagsinput.vue?vue&type=script&lang=js"
import style0 from "./Tagsinput.vue?vue&type=style&index=0&id=03e8221b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e8221b",
  null
  
)

export default component.exports